import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Providers } from './app/providers'
import { router } from './app/routes'
import { initSentry } from './config/sentry'
import { setupSentryInterceptors } from './lib/api/sentryInterceptor'
import { initGA4 } from './utils/analytics'
import '@emran-alhaddad/saudi-riyal-font/index.css'
import './styles/globals.css'

// 1. Initialize Sentry FIRST (catches errors from first render)
initSentry()

// 2. Attach Sentry Axios interceptors (spans, breadcrumbs, captureException)
setupSentryInterceptors()

// 3. Initialize GA4 (direct gtag — GTM is loaded from index.html)
initGA4('G-CTX52JH1QF')

// 4. Render
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
